// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { QuoteMode } from 'pages/QuoteView/Quoting/RequestQuickQuote/types';
import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

export interface QuickQuoteCustomAccessorialsResponse {
  accessorials: QuickQuoteCustomAccessorial[];
}

export interface QuickQuoteCustomAccessorial {
  quoteType: QuoteMode;
  name: string;
  description: string;
  charge: string;
  notes: string;
}

export async function getQuickQuoteCustomAccessorials(
  quoteMode: QuoteMode
): Promise<Result<QuickQuoteCustomAccessorialsResponse, ApiError>> {
  try {
    // Sends "tl" or "ltl". TODO(deprecate-FTL): older sidebar builds send "ftl"; the backend
    // accepts both, so it must deploy before this build ships.
    const { data } = await axios.get<QuickQuoteCustomAccessorialsResponse>(
      `/quote/quickquote/custom-accessorials?quoteMode=${quoteMode.toLowerCase()}`
    );
    return ok(data);
  } catch (error) {
    captureException(error, {
      functionName: 'getQuickQuoteCustomAccessorials',
    });

    if (!isAxiosError(error)) {
      return err({ message: 'Failed to get custom accessorials' });
    }

    return err({
      message:
        error.response?.data.message || 'Failed to get custom accessorials',
    });
  }
}
